import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface PageTitleProps {
	icon: React.ReactNode;
	title: {
		name: string;
		link?: string;
	}[];
}

/**
 * @param title - Array of objects with name and link
 */
export const PageTitle = ({ title, icon }: PageTitleProps) => {
	const navigate = useNavigate();

	const handleClick = (link: string | undefined) => {
		if (link) {
			navigate(link);
		}
	};

	return (
		<div className="text-md flex items-center gap-2 justify-center">
			{icon && (
				<div className="flex items-center gap-2 h-4 w-4 justify-center">
					{icon}
				</div>
			)}
			{title.map((item, index) => (
				<div key={index} className="flex flex-row gap-2 items-center">
					{index !== 0 && (
						<span>
							<ChevronRight size={14} />
						</span>
					)}
					<span
						onClick={() => handleClick(item.link)}
						className={`${
							item.link
								? "hover:underline hover:text-blue-900 cursor-pointer"
								: ""
						} transition-all duration-150 font-normal`}
					>
						{item.name}
					</span>
				</div>
			))}
		</div>
	);
};
